/**
 * FikoMuayene — Muayene/Kalite Raporu (FAI/PPAP) veri modeli
 * Nominal + tolerans (±) vs ölçülen → geç/kal. Otomotiv/havacılık ilk parça onayı (FAI) formu.
 */

export interface MuayeneKarakter {
  no: number;
  ad: string;          // karakteristik adı (örn. "Genel En", "Delik Ø1")
  nominal: number;
  tolUst: number;      // üst tolerans (+ değer, örn. 0.1)
  tolAlt: number;      // alt tolerans (genelde negatif, örn. -0.1)
  olculen: number | null;
  birim: string;       // mm, °, vb.
}

export type MuayeneStat = 'gec' | 'kal' | 'bos';

export interface MuayeneDurum { altSinir: number; ustSinir: number; sapma: number; durum: MuayeneStat; }

/** Bir karakteristiğin geç/kal durumu. */
export function karakterDurum(k: MuayeneKarakter): MuayeneDurum {
  const altSinir = k.nominal + k.tolAlt;
  const ustSinir = k.nominal + k.tolUst;
  if (k.olculen === null || k.olculen === undefined || (k.olculen as any) === '') return { altSinir, ustSinir, sapma: 0, durum: 'bos' };
  const sapma = k.olculen - k.nominal;
  const durum: MuayeneStat = (k.olculen >= altSinir - 1e-9 && k.olculen <= ustSinir + 1e-9) ? 'gec' : 'kal';
  return { altSinir, ustSinir, sapma, durum };
}

export interface MuayeneOzet { toplam: number; gecen: number; kalan: number; bos: number; sonuc: 'KABUL' | 'RED' | 'EKSİK'; }

export function muayeneOzet(liste: MuayeneKarakter[]): MuayeneOzet {
  let gecen = 0, kalan = 0, bos = 0;
  for (const k of liste) { const d = karakterDurum(k).durum; if (d === 'gec') gecen++; else if (d === 'kal') kalan++; else bos++; }
  const sonuc: MuayeneOzet['sonuc'] = kalan > 0 ? 'RED' : bos > 0 ? 'EKSİK' : 'KABUL';
  return { toplam: liste.length, gecen, kalan, bos, sonuc };
}
